import { I_Referrer } from "../interfaces/referrer";
import { Metric } from "./metric";
import { AuthSessionType } from "@dentally/auth/auth-types";

export namespace ConciergeMetrics {
  export class MetricProperties {
    public referrer: I_Referrer;
    public os: string;
    public deviceName: string;
    public browser: string;
    public mode: AuthSessionType;
    public os_version: string;
    public browser_version: string;
    public deviceId: string | null;
  }

  export class ConciergeMetric extends Metric {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(name: string, siteId: string, metricProperties: MetricProperties, additionalProperties: Record<string, any> = {}) {
      super(name, siteId, { ...metricProperties, ...additionalProperties });
    }
  }
}
